import { PlanType } from './plan-type'
import { ServicePlanStepId } from './service-plan-step-id'

// The Angular-side step-definition registry (story e8-1, AC4). This is NOT the same
// artifact as Epic 6's backend PDF section config (ServicePlanSectionDescriptor,
// tsc.common) — see story e8-1 Dev Notes "What 'the definition' means on the Angular
// side" for why these are deliberately two separate artifacts that only need to agree
// on field names, not share one file.
export interface ServicePlanStepDefinition {
  id: ServicePlanStepId
  titleKey: string
  // The plan type(s) this step is ever visible for. Whether it is ALSO conditional on
  // something within that plan type (e.g. 'ndisClassification' additionally requires
  // ndis.hasNdis === true) is handled by getVisibleSteps, not encoded here.
  visibleForPlanTypes: PlanType[]
}

export const SERVICE_PLAN_STEP_DEFINITIONS: ServicePlanStepDefinition[] = [
  {
    id: 'planType',
    titleKey: 'SERVICE_PLAN.STEP.PLAN_TYPE.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'ndisPlan',
    titleKey: 'SERVICE_PLAN.STEP.NDIS_PLAN.TITLE',
    visibleForPlanTypes: ['first'],
  },
  {
    id: 'ndisClassification',
    titleKey: 'SERVICE_PLAN.STEP.NDIS_CLASSIFICATION.TITLE',
    visibleForPlanTypes: ['first'],
  },
  {
    id: 'baselinePackage',
    titleKey: 'SERVICE_PLAN.STEP.BASELINE_PACKAGE.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'familyGoals',
    titleKey: 'SERVICE_PLAN.STEP.FAMILY_GOALS.TITLE',
    visibleForPlanTypes: ['gsp', 'first'],
  },
  {
    id: 'hearingLanguageSupport',
    titleKey: 'SERVICE_PLAN.STEP.HEARING_LANGUAGE_SUPPORT.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'additionalServices',
    titleKey: 'SERVICE_PLAN.STEP.ADDITIONAL_SERVICES.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'cfss',
    titleKey: 'SERVICE_PLAN.STEP.CFSS.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'audiology',
    titleKey: 'SERVICE_PLAN.STEP.AUDIOLOGY.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
  {
    id: 'continuityPlanning',
    titleKey: 'SERVICE_PLAN.STEP.CONTINUITY_PLANNING.TITLE',
    visibleForPlanTypes: ['gsp', 'first'],
  },
  {
    id: 'review',
    titleKey: 'SERVICE_PLAN.STEP.REVIEW.TITLE',
    visibleForPlanTypes: ['transition', 'gsp', 'first'],
  },
]

export function getStepDefinition(
  id: ServicePlanStepId,
): ServicePlanStepDefinition {
  const definition = SERVICE_PLAN_STEP_DEFINITIONS.find((d) => d.id === id)
  if (!definition) {
    throw new Error(`No ServicePlanStepDefinition registered for id "${id}"`)
  }
  return definition
}
